import { useMemo } from 'react';
import { CampaignAccessDTO } from '../../../../../../api/useCampaignAccessQuery';
import { useSameOrgAdvisorsQuery } from '../../../../../../api/useSameOrgAdvisorsQuery';

interface Option {
  label: string;
  value: number;
}

interface UseSameOrgAdvisors {
  campaignAccess: CampaignAccessDTO;
}

export const useSameOrgAdvisors = ({ campaignAccess }: UseSameOrgAdvisors) => {
  const queryInfo = useSameOrgAdvisorsQuery();

  const { relationships } = campaignAccess;

  const options = useMemo(() => {
    if (!queryInfo.data) {
      return [];
    }

    return queryInfo.data.reduce((optionsGroup, advisor) => {
      if (relationships.find(({ adviserId }) => adviserId === advisor.AdviserId)) {
        return optionsGroup;
      }

      return [
        ...optionsGroup,
        {
          label: `${advisor.AdviserFirstName} ${advisor.AdviserLastName} - ${advisor.AdviserEmail}`,
          value: advisor.AdviserId,
        },
      ];
    }, [] as Option[]);
  }, [relationships, queryInfo.data]);

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return [];
    }

    return queryInfo.data.map(({ AdviserId, AdviserLastName, AdviserName, IsManager }) => ({
      adviserId: AdviserId,
      lastName: AdviserLastName,
      firstName: AdviserName,
      isManager: IsManager,
    }));
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
    options,
  };
};
